import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { MappingComponent } from './mapping/mapping.component';
import { LayoutModule } from '../shared/layout/layout.module';
import { UiSwitchModule } from 'ngx-ui-switch';
import { MappingRowComponent } from './mapping/mapping-row/mapping-row.component';
import { MappingDetectPrefixComponent } from './mapping/mapping-detect-prefix/mapping-detect-prefix.component';
import { MappingService } from './mapping/mapping.service';
import { MappingCountryCodeComponent } from './mapping/mapping-row/mapping-country-code/mapping-country-code.component';
import { MappingAssignedNumberComponent } from './mapping/mapping-row/mapping-assigned-number/mapping-assigned-number.component';
import { MatButtonModule, MatSelectModule, MatChipsModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PhoneNumbersComponent } from './phone-numbers/phone-numbers.component';
import { PhoneNumbersService } from './phone-numbers/phone-numbers.service';
import { PhoneNumberRowComponent } from './phone-numbers/phone-number-row/phone-number-row.component';
import { RouterModule } from '@angular/router';
import { CreatorPhoneNumbersComponent } from './phone-numbers/creator-phone-numbers/creator-phone-numbers.component';
import { MappingItemComponent } from './mapping/mapping-item/mapping-item.component';
import { MappingDescriptionComponent } from './mapping/mapping-description/mapping-description.component';
import { MappingItemHeaderComponent } from './mapping/mapping-item-header/mapping-item-header.component';
import { SelectIvrComponent } from './phone-numbers/select-ivr/select-ivr.component';
import { PhoneNumberRecordingComponent } from "./phone-numbers/recording/phone-number-recording.component";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    LayoutModule,
    UiSwitchModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    MatChipsModule,
    RouterModule,
    MatTooltipModule
  ],
  providers: [MappingService, PhoneNumbersService],
  declarations: [
    MappingComponent,
    MappingRowComponent,
    MappingDetectPrefixComponent,
    MappingCountryCodeComponent,
    MappingAssignedNumberComponent,
    PhoneNumbersComponent,
    CreatorPhoneNumbersComponent,
    MappingItemComponent,
    MappingDescriptionComponent,
    MappingItemHeaderComponent,
    SelectIvrComponent,
    PhoneNumberRecordingComponent
  ],
  entryComponents: [MappingComponent, PhoneNumbersComponent, CreatorPhoneNumbersComponent, SelectIvrComponent, PhoneNumberRecordingComponent],
  exports: [MappingComponent, PhoneNumbersComponent, CreatorPhoneNumbersComponent, SelectIvrComponent, PhoneNumberRecordingComponent]
})
export class CampaignSettingsModule {}
